import { keepPreviousData } from '@tanstack/react-query';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppQuery } from '../../../../hooks/use-app-query.hook';
import ApiService from '../../../../services/api-service.util';
import { TemplateRow } from '../components/table/row/template-row.types';
import { TemplateFilter } from '../enums/template-filter.const';

export type GetTemplatesParams = {
  currentPage?: number;
  enabled?: boolean;
  equityPlanId?: string;
  search?: string;
  sortBy?: 'name' | 'status' | 'updatedAt';
  sortOrder?: 'asc' | 'desc';
  status?: TemplateFilter;
  take?: number;
};

type GetTemplatesResponse = {
  count: number;
  records: TemplateRow[];
  totalPages: number;
};

export const useTemplates = (params: GetTemplatesParams) => {
  const { currentPage = 1, enabled = true, take = 10, ...rest } = params;
  const skip = (currentPage <= 1 ? 0 : currentPage - 1) * take;
  const queryParams = { ...rest, skip, take };

  const { data, isPending } = useAppQuery<GetTemplatesResponse>({
    queryKey: [QueryKey.GET_TEMPLATES, queryParams],
    queryFn: () =>
      ApiService.get<GetTemplatesResponse>({ endpoint: BackendRoute.TEMPLATES }, { queryParams }),
    enabled,
    placeholderData: keepPreviousData,
  });

  const templates: TemplateRow[] = data?.records ?? [];
  const count = data?.count ?? 0;
  const totalPages = data?.totalPages ?? 0;

  return {
    templates,
    count,
    totalPages,
    isPending,
  };
};
